/* global axios */
import ApiClient from './ApiClient';

class SzContactsImportAPI extends ApiClient {
  constructor() {
    super('sz_contacts_import', { accountScoped: true });
  }

  templateUrl() {
    return `${this.url}/template.xlsx`;
  }

  // Fetch the template as a blob (carries auth cookies/headers via axios) and
  // trigger a client-side download. Using `<a href download>` would dispatch a
  // raw browser GET without auth, returning a 401 JSON saved as .xlsx — Excel
  // then fails to open it as the user reports.
  async downloadTemplate(filename = 'modelo_contatos.xlsx') {
    const resp = await axios.get(this.templateUrl(), { responseType: 'blob' });
    const blob = new Blob([resp.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  upload(file) {
    const formData = new FormData();
    formData.append('import_file', file);
    return axios.post(`${this.url}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  commit({ rows, labelIds, newLabels }) {
    return axios.post(`${this.url}/commit`, {
      rows,
      label_ids: labelIds || [],
      new_labels: newLabels || [],
    });
  }

  status(importId) {
    return axios.get(`${this.url}/${importId}/status`);
  }
}

export default new SzContactsImportAPI();
